export const CONTENT_HIDE_LOAD_REQUEST = 'CONTENT_HIDE_LOAD_REQUEST';
export const CONTENT_HIDE_LOAD_SUCCESS = 'CONTENT_HIDE_LOAD_SUCCESS';
export const CONTENT_HIDE_LOAD_FAILURE = 'CONTENT_HIDE_LOAD_FAILURE';

export const CONTENT_HIDE_TOGGLE_REQUEST = 'CONTENT_HIDE_TOGGLE_REQUEST';
export const CONTENT_HIDE_TOGGLE_SUCCESS = 'CONTENT_HIDE_TOGGLE_SUCCESS';
export const CONTENT_UNHIDE_TOGGLE_SUCCESS = 'CONTENT_UNHIDE_TOGGLE_SUCCESS';
export const CONTENT_HIDE_TOGGLE_FAILURE = 'CONTENT_HIDE_TOGGLE_FAILURE';
